import { createRoute } from 'framework/routing';

export const BUISNESS_FUNCTION_PATH = '/buisness-functions';

export const useBuisnessFunctionRoute = () => createRoute({ listRoute: BUISNESS_FUNCTION_PATH });
